<template>
  <base-form :title="$t('settings.jobs.title')"
             :loading="loading"
             :show-footer="false"
             class="job-settings"
             @submit="submitForm">
    <template v-slot:content>
      <dl class="-mx-3">
        <div class="list-row"
             v-for="(value, key, index) in model"
             :class="{
               'bg-gray-50': index % 2 === 0,
               'bg-white': index % 2 === 1,
             }"
        >
          <dt class="list-row-dt">
            {{$t(`settings.general.job.${key}`)}}
          </dt>
          <dd class="list-row-dd">
            <base-switch v-model="model[key]"
                         @input="submitForm"
            />
          </dd>
        </div>
      </dl>
    </template>
  </base-form>
</template>
<script>
  import settingsMixin from './settingsMixin'

  export default {
    name: 'job-settings',
    mixins: [settingsMixin],

    data () {
      return {
        loading: false,
        model: {
          job_field_show_description: false,
          job_field_text_blocks: false,
          job_field_show_pixel_url: false,
          job_field_show_recruiter_name: false,
          job_field_show_recruiter_phone: false,
          job_field_show_recruiter_email: false,
          job_field_show_recruiter_website: false,
          job_field_show_hours: false,
          job_allow_to_hide_apply_button: false,
          job_field_show_salary: false,
          job_organisation_create_new: false
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async submitForm () {
        let res = await this.$validator.validateAll()
        if (res) {
          try {
            this.loading = true
            await this.updateSettings()
            this.$notify({type: 'success', message: this.$t('settings.general.success')})
          } catch (e) {
            this.$notify({type: 'danger', message: this.$t('settings.general.error')})
          } finally {
            this.loading = false
          }
        }
      }
    }
  }
</script>
<style scoped>
  .job-settings .list-row {
    @apply py-4;
  }
</style>
